import BaseComponent from "../../../../../lib/components/BaseComponent";
import VerticalLayout from "../../../../../lib/components/layouts/VerticalLayout";
import InputLayoutType from "../../../../../appl/view/components/inputFields/InputLayoutType";
import InputText from "../../../../../appl/view/components/inputFields/InputText";

class InputTextMultilineTest extends BaseComponent {

    render() {
        return <div className='sandbox-container flex flex-col gap-4'>
            <VerticalLayout className={' self-center'}>
                <h1>InputTextMultilineTest</h1>
                <InputText labelElement='TestInputHtml' helpTextElement='helpText hier' inputLayout={InputLayoutType.inline}/>
            </VerticalLayout>
        </div>
    }
}

export default InputTextMultilineTest;
